import _sfc_main from "./VideoProfile.vue2.mjs";
/* empty css                   */
import normalizeComponent from "../../_virtual/_plugin-vue2_normalizer.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.TuiSelect, { staticClass: "select", attrs: { "placeholder": "placeholder", "teleported": false, "popper-append-to-body": false }, model: { value: _setup.localVideoQuality, callback: function($$v) {
    _setup.localVideoQuality = $$v;
  }, expression: "localVideoQuality" } }, _vm._l(_setup.videoProfileList, function(item, index) {
    return _c(_setup.TuiOption, { key: index, attrs: { "label": item.label, "value": item.value } });
  }), 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "c656fc9a"
);
const VideoProfile = __component__.exports;
export {
  VideoProfile as default
};
